const config = {
  "localhost": {
    API_URL : "sofca-app.localhost/webapp",
  },
  "integration.sofca-app.presta-concept.net": {
    API_URL : "integration.sofca-app.presta-concept.net/webapp",
  },
  "recette.sofca-app.presta-concept.net": {
    API_URL : "recette.sofca-app.presta-concept.net/webapp",
  },
  "autocertifnoa.sofca.net": {
    API_URL : "autocertifnoa.sofca.net/webapp",
  },
}

const domain = Object.keys(config).find(domain => {
  return location.host.includes(domain)
})

export default config[domain]
